import { REPORT } from "../constants";

const initialState = {
  totalReportStats: {
    denchu: "-",
    hh: "-",
    mh: "-",
  },
  reportData: [],
  reportTagFilterData: [],
  totalReportCount: "--",
  currentPageNumber: 1,
  filteredTotal: "--",
  filter: {
    type: "occurred_datetime",
    order: "desc",
    tag: [],
    tagResult: [],
    filterType: "report",
    assetId: null,
    signNumber: null,
    assetType: "all",
    manageGroup: {
      key: "all",
      value: [],
    },
    reportTime: "all",
  },
  downloadData: [],
  reportImageData: [],
  reportImageDataByOthers: [],
  reportNoImageData: false,
  reportDataNtt: [],
  reportTagFilterDataNtt: [],
  reportDataMission: [],
  reportTagFilterDataMission: [],
  filterNtt: {
    type: "occurred_datetime",
    order: "desc",
    tag: [],
    filterType: "photo",
    assetId: null,
    assetType: "all",
    prefecturalArea: "all",
    exchangeOfficeName: "all",
    assetInfo: "all",
    photographyTarget: "all",
    photoType: "all",
    twoStepVerification: "all",
    resultTag: "all",
  },
  reportDataHokuden: [],
  reportTagFilterDataHokuden: [],
  filterHokuden: {
    type: "occurred_datetime",
    order: "desc",
    tag: [],
    filterType: "photo",
    assetId: null,
    assetType: "all",
    powerAssetNumber: null,
    areaName: "all",
    username: "all",
    municipality: "all",
    branchName: "all",
    resultTag: "all",
  },
  hokudenOptionCity: [],
  hokudenOptionBranch: [],
  filterMission: {
    type: "occurred_datetime",
    order: "desc",
    tag: [],
    filterType: "photo",
    areaName: "all",
    username: "all",
    municipality: "all",
    branchName: "all",
    resultTag: "all",
  },
};

export default function reportReducer(state = initialState, action) {
  switch (action.type) {
    case REPORT.SET_TOTAL_STATS_DATA:
      return {
        ...state,
        totalReportStats: action.payload,
      };
    case REPORT.SET_REPORT_DATA:
      return {
        ...state,
        reportData: action.payload,
      };
    case REPORT.SET_REPORT_TAG_FILTER_DATA:
      return {
        ...state,
        reportTagFilterData: action.payload,
      };
    case REPORT.SET_REPORT_TOTAL_IMAGE_COUNT:
      return {
        ...state,
        totalReportCount: action.payload,
      };
    case REPORT.SET_REPORT_CURRENT_PAGE_NUMBER:
      return {
        ...state,
        currentPageNumber: action.payload,
      };
    case REPORT.SET_REPORT_FILTERED_TOTAL:
      return {
        ...state,
        filteredTotal: action.payload,
      };
    case REPORT.SET_REPORT_FILTER:
      return {
        ...state,
        filter: action.payload,
      };
    case REPORT.SET_DOWNLOAD_REPORT_DATA:
      return {
        ...state,
        downloadData: action.payload,
      };
    case REPORT.SET_IMAGE_DATA_BY_REPORT_ID:
      return {
        ...state,
        reportImageData: action.payload,
      };
    case REPORT.SET_IMAGE_DATA_BY_OTHER_USERS:
      return {
        ...state,
        reportImageDataByOthers: action.payload,
      };
    case REPORT.SET_NO_IMAGE_DATA_BY_REPORT_ID:
      return {
        ...state,
        reportNoImageData: action.payload,
      };
    case REPORT.SET_REPORT_FILTER_NTT:
      return {
        ...state,
        filterNtt: action.payload,
      };
    case REPORT.SET_REPORT_DATA_NTT:
      return {
        ...state,
        reportDataNtt: action.payload,
      };
    case REPORT.SET_REPORT_TAG_FILTER_DATA_NTT:
      return {
        ...state,
        reportTagFilterDataNtt: action.payload,
      };
    case REPORT.SET_REPORT_DATA_MISSION:
      return {
        ...state,
        reportDataMission: action.payload,
      };
    case REPORT.SET_REPORT_TAG_FILTER_DATA_MISSION:
      return {
        ...state,
        reportTagFilterDataMission: action.payload,
      };
    case REPORT.SET_REPORT_FILTER_HOKUDEN:
      return {
        ...state,
        filterHokuden: action.payload,
      };
    case REPORT.SET_REPORT_DATA_HOKUDEN:
      return {
        ...state,
        reportDataHokuden: action.payload,
      };
    case REPORT.SET_REPORT_TAG_FILTER_DATA_HOKUDEN:
      return {
        ...state,
        reportTagFilterDataHokuden: action.payload,
      };
    case REPORT.SET_HOKUDEN_REPORT_OPTION_CITY:
      return {
        ...state,
        hokudenOptionCity: action.payload,
      };
    case REPORT.SET_HOKUDEN_REPORT_OPTION_BRANCH:
      return {
        ...state,
        hokudenOptionBranch: action.payload,
      };
    default:
      return state;
  }
}
